import React from "react";

interface AgreeTermsProps {
  onClickLink: () => void;
  name: string;
  isChecked: boolean;
  onChangeCheck: () => void;
}

export const AgreeTerms = ({
  onClickLink,
  name,
  isChecked,
  onChangeCheck,
}: AgreeTermsProps) => {
  return (
    <div className="flex items-center space-x-2">
      <i
        onClick={onChangeCheck}
        className={`
          fa ${isChecked ? 'fa-square-check' : 'fa-regular fa-square'} 
          text-2xl text-ptTeal active:text-ptTeal-100 transition duration-200 hover:scale-105 active:scale-95
        `}
      />
      <label htmlFor="terms" className="text-gray-700 flex flex-row gap-x-2">
        <div>
          我同意
        </div>
        <div
          onClick={onClickLink}
          className="font-bold underline hover:text-blue-800 active:text-blue-600"
        >
          {name}
        </div>
      </label>
    </div>
  )
}
